import dayjs, { APP_TIMEZONE } from '@shared/lib/dayjs';

/**
 * Format an ISO timestamp as HH:mm in Asia/Tokyo. Returns '--:--' for null /
 * invalid input — matches the placeholder VisitCard uses for not-yet-started
 * visits.
 */
export function formatHHmm(iso: string | null): string {
  if (!iso) return '--:--';
  const d = dayjs(iso).tz(APP_TIMEZONE);
  return d.isValid() ? d.format('HH:mm') : '--:--';
}
